import { type DependencyList, useEffect } from 'react'

export default function useInvisibleUntilFontsLoaded(
	containerRef: React.RefObject<HTMLElement>,
	after: () => void,
	deps?: DependencyList,
) {
	useEffect(() => {
		void document.fonts.ready.then(() => {
			if (!containerRef.current) return

			// Make the container visible once fonts are loaded
			containerRef.current.style.visibility = 'visible'

			after()
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [containerRef, after, ...(deps ? deps : [])])
}
